import React, { useRef } from "react";
import styles from '../../styles/countryadmissionsday.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
interface Props {
    coursedata: any;
}

const PopularCourses: React.FC<Props> = ({ coursedata }) => {
    const sliderRef = useRef<Slider>(null);
    const settings = {
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 3,
        slidesPerRow: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,

                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dotsClass: styles.sliderDots,
                    dots: true,
                }
            }
        ]
    };
    return (
        <>
            <div className={styles.popularcourses} style={{ backgroundColor: coursedata?.sectionBgColor || "#FFF1EF" }}>
                <div>
                    <Container>
                        <Row>
                            <div className={styles.heading}>
                                <h1>{coursedata?.sectionTitle}</h1>
                            </div>
                        </Row>
                    </Container>
                    <Container>
                        <Row>
                            <div className={styles.popularCourseslider}>
                                <Slider {...settings} className={styles.slider} ref={sliderRef}>
                                    <div>
                                        <Row>
                                            {
                                                coursedata?.pointImage?.length > 0 &&
                                                coursedata?.pointImage?.map((offer: any, ind: number) => {
                                                    return (
                                                        <Col xl={6} lg={6} md={6} sm={12} xs={6} key={ind}>
                                                            <div className={styles.mainBox}>
                                                                <div className={styles.box}>
                                                                    <div className={styles.img}>
                                                                        <CustomImage src={offer.imageUrl || "/images/admissionsday/popularstart.png"} width={60} height={60} className={styles.studImg} alt="handshake.png" />
                                                                    </div>
                                                                    <div className={styles.para}>
                                                                        <p> {offer?.title}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    )
                                                })
                                            }
                                        </Row>
                                    </div>
                                </Slider>
                            </div>
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    )
}
export default PopularCourses;